import { render, staticRenderFns } from "./18ProcessNoValuation.vue?vue&type=template&id=317c7f96&"
import script from "./18ProcessNoValuation.vue?vue&type=script&lang=js&"
export * from "./18ProcessNoValuation.vue?vue&type=script&lang=js&"
import style0 from "./18ProcessNoValuation.vue?vue&type=style&index=0&id=317c7f96&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports